<div class="po-row" style="padding-top: 2em; padding-bottom: 2em;">
  <p class="insumoTitle npl po-xl-1 po-lg-1 po-md-1 po-sm-1" style="width: 5%">{{ literalsCp?.strInsumos | uppercase }}</p>
  <hr class="po-xl-11 po-lg-11 po-md-11 po-sm-11" style="margin-top: 30px; width: 95%" />
</div>

<po-multiselect #costgroupmultiselect
[(ngModel)]="optionsSelected"
[p-options]="optionsMultiSelect"
[p-placeholder]="placeholder"
(p-change)="CostGroupChange()">
</po-multiselect>

<div style="position:relative"> 
  <div *ngIf="taskInput && taskInput.items.length > 0; else NenhumInsumo">
    <div *ngFor="let item of itemsInputs">
      <div class="po-row" style="margin-top: 2em;">
        <div class="circuloInsumo po-xl-1 po-lg-1 po-md-1 po-sm-1"><span class="po-icon po-icon-stock iconMiddle"
            style="font-size: 20px;"></span></div>
        <span class="insumoDescripton po-xl-11 po-lg-11 po-md-11 po-sm-11">{{ item.description }}</span>
      </div>

      <div class="po-row" style="padding-left: 4px;">
        <p class="inputCode po-page-content np po-xl-12 po-lg-12 po-md-12 po-sm-12">{{ literalsCp?.strCod | uppercase  }} {{ item.inputCode }}</p>
      </div>

      <cp-inputcharts name="inputChartsTask" [inputInfo]="item"></cp-inputcharts>
    </div>

    <div style="position: relative">
      <cp-loading-button #ContainerButtonVejaMais [hasNext]="this.taskInput.hasNext" (click)="load()"></cp-loading-button>
      <po-loading-overlay [hidden]="IsHideLoadingVejaMais"></po-loading-overlay>
    </div>
  </div>

  <po-loading-overlay [hidden]="IsHideLoadingContainer"></po-loading-overlay>
</div>

<ng-template #NenhumInsumo>
  <p style="margin-top: 2em;">{{ literalsCp?.strNenhumRegistroEncontrado }}</p>
</ng-template>